import React from 'react';

import InputField from '../Inputs/InputField';
import InputSelect from '../Inputs/InputSelect';

import Modal from '../Modal/Modal';
import HelpBox2 from '../HelpBox/HelpBox2'

import { ReactComponent as LoadIcon } from '../../icons/loading.svg';
import { ReactComponent as ErrorIcon } from '../../icons/error.svg';
import { ReactComponent as SuccessIcon } from '../../icons/success.svg';

import Helper from '../../helper';

const _ = require('lodash');


class ProjectPageSolar extends React.Component {

	constructor(props) {
		super(props)

		this.state = {

			refData: null,

			displayIndex: 0, // index of which input menu to display

			dlPending: false,
			dlSuccess: false,
			dlFail: false,

			formatPending: false,
			formatSuccess: false,
			formatFail: false,

			isFormatted: false,

			dataErrorMsg: '',

			delay: 2000,

			newSolarData: null

		}

		this.renderRefMenu = this.renderRefMenu.bind(this);
		this.render8760Menu = this.render8760Menu.bind(this);
		this.returnToFormatter = this.returnToFormatter.bind(this);
		this.downloadData = this.downloadData.bind(this);
		this.toggleFormatted = this.toggleFormatted.bind(this);
		this.writeUserData = this.writeUserData.bind(this);


	}

	switchFormIndex(newIndex) {
		this.setState({
			displayIndex:newIndex,
			isFormatted: false // set formatted flag to false on any menu switch
		})
	}

	returnToFormatter() {
		// drops all state flags, so that component renders the menu

		this.setState(
			{
				dlPending: false,
				dlSuccess: false,
				dlFail: false,
				formatPending: false,
				formatSuccess: false,
				formatFail: false,
				dataErrorMsg: ''
			}
		)
	}

	toggleFormatted() {

		// if isFormatted currently false, run process8760 func in props
		if (!this.state.isFormatted) {
			this.props.processSolar8760()
		}

		// toggle current isFormatted state
		this.setState({isFormatted:!this.state.isFormatted})
	}


	async downloadData() {

		await this.setState({dlPending:true})

		// download data from server
		await Helper.sleep(this.state.delay)

		// check that bldg id has been selected
		if(!Number.isInteger(this.props.loc_stationId) || this.props.loc_stationId<0){
			var dataErrorMsg = "Station ID missing or invalid."
			this.setState({dlPending:false, dlFail: true, dataErrorMsg: dataErrorMsg})
			return
		}

		if(!Number.isInteger(this.props.loc_stationId) || !this.props.loc_stationId<0){
			var dataErrorMsg = "Station ID missing or invalid."
			this.setState({dlPending:false, dlFail: true, dataErrorMsg: dataErrorMsg})
			return
		}


		// url to fetch data for building reference library
		let urlPvData = `${process.env.REACT_APP_URL_BASE}/data/pv/dl?locId=${this.props.loc_stationId}`;
		console.log(urlPvData)
		var refData = [];

		let response = await fetch(urlPvData, {credentials: 'include'});

	    // if status GET request successful
	    if(response.status===200) {
	      	refData = await response.json();
	    } else {
	    	var dataErrorMsg = "Server failed to return requested PV data"
			this.setState({dlPending:false, dlFail: true, dataErrorMsg: dataErrorMsg})
			return
	    }

		
		// create copy of load template
		var newPVData = _.cloneDeep(this.props.pvTemplate)
		const refPVData = _.cloneDeep(refData.data)

		// get month keys for refPVData
		const mKeys = Object.keys(refPVData); // month key list

		// loop through ref data keys
		for(let mm=0; mm<mKeys.length; mm++) {
			
			// get current keys
			let mKey = mKeys[mm];

			// get hourly data from ref data
			let hourlyData = refPVData[mKey];

			// round data to 4 decimal places
			hourlyData = hourlyData.map((val) => {
				return +(val).toFixed(4);
			})


			// get indices of current month key from template data
			let mInd = newPVData.rowLabels.indexOf(Helper.capitalizeFirst(mKey)); // have to capitalize month due to format mismatch


			// check that indices all successfully found
			if(mInd < 0) {
				console.log(`cannot find index for ${mKey}`)
				continue
			} else {
				// console.log(`copying data for ${eKey} ${dKey} ${mKey}`)
				// console.log(hourlyData)
			}

			// if all indices found, apply data to template
			newPVData.data[mInd] = hourlyData
				
		}


		// determine destination table location
		const destTableName = 'normalizedpvoutput'


		// write new data to table
		var writeStatus = this.props.replaceTable(newPVData, destTableName)
		// var writeStatus = {
		// 	success: true,
		// 	msg: "NO DATA WRITTEN. DISABLED FOR TESTING"
		// }


		// if success, return to formatter
		if(writeStatus.success){
			await this.setState({dlPending:false, dlSuccess: true, refData: refData, newPVData:newPVData})
		} else {
			var dataErrorMsg = writeStatus.msg
			await this.setState({dlPending:false, dlFail: true, refData: refData, newPVData:newPVData, dataErrorMsg:dataErrorMsg})
		}

		

	}

	async writeUserData() {

		// method for processing user-provided 8760 data
		// and writing to table data

		await this.setState({formatPending:true})

		// download data from server
		await Helper.sleep(2000)

		// get table key from props solar_table_name
		let solar_table_map = {
			'normalizedpvoutput': 'Normalized PV Output',
			'solarinsolation': 'Solar Insolation'
		}

		function findKeyByValue(obj, value) {
		  return Object.keys(obj).find(key => obj[key] === value) || false;
		}

		let solar_table_key = findKeyByValue(solar_table_map, this.props.solar_table_name);

		// check that solar table is valid
		if(!solar_table_key){
			var dataErrorMsg = "Invalid table selected. Please select valid table where solar data should be written"
			this.setState({formatPending:false, formatFail: true, dataErrorMsg: dataErrorMsg})
			return
		}

		// create copy of pv template
		var newSolarTableData = _.cloneDeep(this.props.pvTemplate)
		

		// get the processed user-defined load data from props
		newSolarTableData.data = this.props.solarDataFormatted
		newSolarTableData.key = solar_table_key 
        newSolarTableData.label = this.props.solar_table_name

		// determine destination table location
		const destTableName = solar_table_key 

		console.log(newSolarTableData)


		// write new data to table
		var writeStatus = this.props.replaceTable(newSolarTableData, destTableName)


		// if success, return to formatter
		if(writeStatus.success){
			await this.setState({formatPending:false, formatSuccess: true, newSolarData:newSolarTableData})
		} else {
			var dataErrorMsg = writeStatus.msg
			await this.setState({formatPending:false, formatFail: true, newSolarData:newSolarTableData, dataErrorMsg:dataErrorMsg})
		}

	}


	renderMenuSelector() {
		// func displays buttons for switching input form

		const menuButtonData = [
			{
				label: 'Load Reference Data',
				index: 0,
				active: false
			},
			{
				label: 'Upload 8760 Data',
				index: 1,
				active: false
			}
		]

		menuButtonData[this.state.displayIndex].active = true

		const menuButtonHtml = menuButtonData.map((btnData)=>{

			// add active class if current btn is active
			var btnClass = 'text-button input-select-button'

			if (btnData.active) {
				btnClass += ' input-select-button-active'
			}

			return(
				<div className={btnClass} onClick={()=>{this.switchFormIndex(btnData.index)}}>
					<h2>{btnData.label}</h2>
				</div>
			)
		})

		return(
			<>
			<h2 className='npdc-subheader'> Select Input Method </h2>
			<br/>
			<div className='centered-row-container'>
			{menuButtonHtml}	
			</div>
			</>
		)

	}

	renderRefMenu() {
		// method renders the menu section for importing reference data

		return(				
			<div className='npdc-section'>

				<h2 className='npdc-subheader'> Reference Solar PV Data </h2>

				<HelpBox2
					label='More Info'
				>
					<p className='npdc-text'>
						Use this menu to process to import reference Normalized PV generation
						profiles for existing U.S. weather station locations. Select PV configuration,
						and press download when ready. New data will then be written to current
						project input table. Note: this importer currently on works for normalized PV
						output. It does not population general solar irradiation (e.g. for solar thermal assets).
					</p>
				</HelpBox2>


				<table className='npdc-grid-table'>
					<tr>
						<td className='npdc-input-label'>
							State
						</td>
						<td>
							<InputSelect
								// props needed: itemList, fieldName, formValue, onChange
								itemList={this.props.stateList}
								fieldName='loc_stateUs'
								fieldLabel={null}
								formValue={this.props.loc_stateUs}
								onChange={this.props.handleChangePvStation}
								inTable={true}
							/>
						</td>
						<td>
							
						</td>
					</tr>

					<tr>
						<td className='npdc-input-label'>
							Station Location
						</td>
						<td>
							<InputSelect
								// props needed: itemList, fieldName, formValue, onChange
								itemList={this.props.stationList}
								fieldName='loc_station'
								fieldLabel=''
								formValue={this.props.loc_station}
								onChange={this.props.handleChangePvStation}
							/>
						</td>
						<td>
							
						</td>
					</tr>

					<tr>
						<td className='npdc-input-label'>
							PV Angle
						</td>
						<td>
							<InputSelect
								// props needed: itemList, fieldName, formValue, onChange
								itemList={this.props.pvAngleList}
								fieldName='pvAngle'
								fieldLabel={null}
								formValue={this.props.pvAngle}
								onChange={this.props.handleChange}
								inTable={true}
								data-type='str'
							/>
						</td>
						<td>
							
						</td>
					</tr>

					<tr>
						<td className='npdc-input-label'>
							PV Orientation
						</td>
						<td>
							<InputSelect
								// props needed: itemList, fieldName, formValue, onChange
								itemList={this.props.pvOrientList}
								fieldName='pvOrient'
								fieldLabel={null}
								formValue={this.props.pvOrient}
								onChange={this.props.handleChange}
								inTable={true}
								data-type='str'
							/>
						</td>
						<td>
							
						</td>
					</tr>

				</table>

				<br/>

				<div className='text-button npdc-button' onClick={this.downloadData}>
					<h2>Download & Apply</h2>
				</div>

			</div>
		)
		
	}



	render8760Input() {

	}

	renderInput8760() {
		// method renders input fields for user 8760 data
		return(
			<>
				<tr>
					<td colSpan='2'>
						<textarea 
				          name='solarProfile'
				          className='npdc-load-form-area'
				          value={this.props.solarProfile} 
				          onChange={this.props.handleChange} 
				          required
				        /> 
					</td>
				</tr>

			</>
		)

	}

	renderStatus8760() {
		// renders a div with status of formatted data if isFormatted in props is true	

		return(
			<>
				<tr>
					<td className='npdc-input-label'>
						Solar Profile
					</td>
					<td className='npdc-static-data'>
						{`${this.props.solarProfileLen} values found`}
					</td>
					<td className='npdc-unit-label'>
						
					</td>
				</tr>

				
			</>
		)
	}


	render8760Menu() {
		// method renders the menu section for processing user data manually

		return(
			<div className='npdc-section'>

				<h2 className='npdc-subheader'> Custom Solar Formatter </h2>

				<HelpBox2
					label='More Info'
				>
					<p className='npdc-text'>
						Use this menu to process custom solar profile data. Please paste 
						comma, space, or new line delimited, hourly (8760) solar data into the input field. 
						Select the solar metric to be defined and press the Process button
						when ready.
						<br/><br/>
						The formatter expects to receive 8760 values from Jan 1 to Dec 31 of the modeled year.
						If it finds additional values, it will only use the first 8760 entries. If it finds fewer
						values, it will populate the remainder of the required values with '0'
						<br/><br/>
						You may use this menu to write custom data for either Normalized PV Generation or Solar Insolation.
					</p>
				</HelpBox2>

				<table className='npdc-grid-table'>

					<tr className={`${Helper.showHideHtml(true)}`}>
						<td className='npdc-grid-header' colSpan='2'>
							Annual Hourly Load Profiles
						</td>
					</tr>

					
					{!this.state.isFormatted ? this.renderInput8760() : this.renderStatus8760()}

					{/*"key": "normalizedpvoutput",
            		"label": "Normalized PV Output",
            		"key": "solarinsolation",
		            "label": "Solar Insolations",*/}
							

					<tr>
						<td><br/><br/></td>
					</tr>

					<tr>
						<td className='npdc-input-label'>
							Apply to Table
						</td>
						<td>
							<InputSelect
								// props needed: itemList, fieldName, formValue, onChange
								itemList={["Normalized PV Output", "Solar Insolation"]}
								fieldName='solar_table_name'
								fieldLabel={null}
								formValue={this.props.solar_table_name}
								onChange={this.props.handleChange}
								inTable={true}
								data-type='int'
							/>
						</td>
						<td>
							
						</td>
					</tr>

				</table>

				<br/>

				<div className='text-button npdc-button' onClick={this.toggleFormatted}>
					<h2>{!this.state.isFormatted ? 'Check & Format Data' : 'Update Custom Data'} </h2>
				</div>

				<br/>

				{/*{this.renderDataStatus}*/}

				{this.state.isFormatted ? 
						<div className='text-button npdc-button' onClick={this.writeUserData}>
							<h2>Apply Formatted Data</h2>
						</div>
					:
						<div className='text-button npdc-button text-button-disabled'>
							<h2>Apply Formatted Data</h2>
						</div>
				}

			</div>
		)
		
	}


	render() {

		if(this.state.dlPending){
			return(
				<div className='page-scroll-container-new-project project-main-container'>

					<div className='npdc-container'>
						<Modal
			  				icon={<LoadIcon />}
							label={<>Downloading & Applying Reference Data</>}
							rotating={true}
			  			>

			  			</Modal>
		  			</div>
		  		</div>
			)
		}

		if(this.state.dlSuccess){
			return(
				<div className='page-scroll-container-new-project project-main-container'>

					<div className='npdc-container'>
						<Modal
			  				icon={<SuccessIcon />}
							label={<>New Reference Data <br/>Successfully Written to Model</>}
							rotating={false}
			  			>
			  				<div className='modal-btn dark-btn' onClick={this.returnToFormatter}>
								<h2 className='modal-btn-text'> Return to PV Menu </h2>
							</div>

		  				</Modal>
	  				</div>
		  		</div>
			)
		}

		if(this.state.dlFail){
			return(
				<div className='page-scroll-container-new-project project-main-container'>

					<div className='npdc-container'>
						<Modal
			  				icon={<ErrorIcon />}
							label={<>Data Download Failed</>}
							rotating={false}
							modalText={
								'An error occurred when downloading or formatting the requested PV data.'+
								' Please return to the Solar menu and retry after a few minutes.'
							}
			  			>
			  				<div className='modal-text'>
								<br/><p>{`Error Msg: ${this.state.dataErrorMsg}`}</p>
							</div>

			  				<div className='modal-btn dark-btn' onClick={this.returnToFormatter}>
								<h2 className='modal-btn-text'> Return to PV Menu </h2>
							</div>

			  			</Modal>
		  			</div>
		  		</div>
			)
		}

		// status modals for formatting user data
		if(this.state.formatPending){
			return(
				<div className='page-scroll-container-new-project project-main-container'>

					<div className='npdc-container'>
						<Modal
			  				icon={<LoadIcon />}
							label={<>Processing User Solar Data</>}
							rotating={true}
			  			>

			  			</Modal>
		  			</div>
		  		</div>
			)
		}

		if(this.state.formatSuccess){
			return(
				<div className='page-scroll-container-new-project project-main-container'>

					<div className='npdc-container'>
						<Modal
			  				icon={<SuccessIcon />}
							label={<>User Solar Data <br/>Successfully Written to Model</>}
							rotating={false}
			  			>
			  				<div className='modal-btn dark-btn' onClick={this.returnToFormatter}>
								<h2 className='modal-btn-text'> Return to Solar Menu </h2>
							</div>

		  				</Modal>
	  				</div>
		  		</div>
			)
		}

		if(this.state.formatFail){
			return(
				<div className='page-scroll-container-new-project project-main-container'>

					<div className='npdc-container'>
						<Modal
			  				icon={<ErrorIcon />}
							label={<>User Solar Data Processing Failed</>}
							rotating={false}
							modalText={
								'An error occurred when processing or formatting user load data.'+
								' Please check the provided load data and try again.'
							}
			  			>
			  				<div className='modal-text'>
								<br/><p>{`Error Msg: ${this.state.dataErrorMsg}`}</p>
							</div>

			  				<div className='modal-btn dark-btn' onClick={this.returnToFormatter}>
								<h2 className='modal-btn-text'> Return to Solar Menu </h2>
							</div>

			  			</Modal>
		  			</div>
		  		</div>
			)
		}

		// define list of menus to display, selected bases on self.state.displayIndex
		const displayFuncList = [
			this.renderRefMenu,
			this.render8760Menu			
		];

		let displayFunc = displayFuncList[this.state.displayIndex]

		return(
			<div className='page-scroll-container-new-project project-main-container'>

				<div className='npdc-container'>
					<h1 className='npdc-header'> Solar Data Menu </h1>
	    			
	    			<div className='npdc-panel'>

	    				<div className='npdc-section'>
							{this.renderMenuSelector()}
						</div>

	    				{displayFunc()}
					</div>	
				
				</div>

	    	</div>
		)

	}
}



export default ProjectPageSolar;